import { TAG_CLICKED } from '../../actions/tag-clicked';

const handler = ({ payload }) => {
  const { label, id, postId } = payload;

  return {
    evid: 212,
    post_id: postId,
    tag_name: label,
    tagId: id,
    eventMeta: {
      description: 'tag clicked',
    },
  };
};

export const uouTagClickedEvent = { [TAG_CLICKED]: handler };
